import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './i18n-en';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en }
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

const languageLoaders: Record<string, () => Promise<{ default: Record<string, unknown> }>> = {
  es: () => import('./i18n-es'),
  ar: () => import('./i18n-ar'),
  fr: () => import('./i18n-fr'),
};

const loadedLanguages = new Set(['en']);

export async function loadLanguage(lng: string): Promise<void> {
  if (loadedLanguages.has(lng) || !languageLoaders[lng]) return;
  const mod = await languageLoaders[lng]();
  i18n.addResourceBundle(lng, 'translation', mod.default, true, true);
  loadedLanguages.add(lng);
}

const detectedLng = i18n.language?.split('-')[0];
if (detectedLng && languageLoaders[detectedLng]) {
  loadLanguage(detectedLng).then(() => {
    i18n.changeLanguage(detectedLng);
  });
}

i18n.on('languageChanged', (lng: string) => {
  const baseLng = lng.split('-')[0];
  if (!loadedLanguages.has(baseLng) && languageLoaders[baseLng]) {
    loadLanguage(baseLng).then(() => {
      i18n.changeLanguage(baseLng);
    });
  }
});

export default i18n;
